import { KeycloakService } from "keycloak-angular";
import { environment } from "../../environments/environment";

export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.Keycloak_url,
        realm: 'smivap',
        clientId: 'trasparenza-webapp-client'
      },
      initOptions: {
        // 1. Diciamo a Keycloak di controllare sempre se c'è una sessione al caricamento (F5)
        onLoad: 'check-sso', 
        
        checkLoginIframe: false,
        
        // 2. Decommentiamo e aggiungiamo il /v2/ al percorso dell'iframe invisibile
        silentCheckSsoRedirectUri: window.location.origin + '/v2/assets/config/silent-check-sso.html'
      },
      enableBearerInterceptor: true,
      bearerPrefix: 'Bearer'
    });
}